export default __webpack_public_path__ + "static/media/twitter.bf44282b.svg";